import { InfoTranslateions } from './types';

export enum InfoTranslationsVariant {
  title = 'title',
  btn = 'btn',
  info = 'info',
}

export const INITIAL_INFO_TRANSALTIONS: Partial<InfoTranslateions> = {
  btn: 'Хорошо',
};
